import React from 'react';
import VehicleRegistrationDialog from '../common/VehicleRegistrationDialog';
import { PARTY_KIND } from '../../constants/partyKindLookupConstants';

const PersonVehicleRegistrationDialog = (props) => (
  <VehicleRegistrationDialog {...props} partyType={PARTY_KIND.PERSON} />
);

export default PersonVehicleRegistrationDialog;
